(function() {
    'use strict';

    angular.module('order')
        .controller('OrderDetailsController', OrderDetailsController);

    OrderDetailsController.$inject = [
        '$state',
        '$q',
        'orderDataSrvc',
        'orderSrvc',
        'orderLogDataSrvc',
        'orderStatusConst',
        'orderPaymentConst',
        'notificationSrvc',
        'orderUpdateMessagesConst',
        'orderDeliveriesDataSrvc',
        '$uibModal',
        'orderDeliveryAddressPermissionsConst',
        'checkModelPermissionsSrvc',
        'orderPermissionsConst',
        'invoicePermissionsConst',
        'downloadLinkSrvc',
        'clientDataSrvc',
        'modalSrvc',
        'previewSrvc',
        'orderproductPermissionsConst',
        'orderProductEditModalSrvc',
        'previewModalSrvc',
        'datatableDefaultPageSizeValueConst',
        'datatableDefaultEmptyValueConst',
        'errorNotificationSrvc',
        'orderDeliveryPackageDataSrvc',
        'orderDeliveryPackageMessageConst',
        'noteModalSrvc',
        'notesDataSrvc',
        'notesPageSizeConst',
        'notesPermissionsConst',
        'sourceFileModalSrvc',
        'orderShelfPermissionsConst',
        'orderShelfModalSrvc',
        'orderShelfDataSrvc',
        'montageDataSrvc',
        'allegroThreadsDataSrvc'
    ];

    function OrderDetailsController(
        $state, $q, orderDataSrvc, orderSrvc, orderLogDataSrvc, orderStatusConst, orderPaymentConst, notificationSrvc,
        orderUpdateMessagesConst, orderDeliveriesDataSrvc, $uibModal, orderDeliveryAddressPermissionsConst,
        checkModelPermissionsSrvc, orderPermissionsConst, invoicePermissionsConst, downloadLinkSrvc, clientDataSrvc,
        modalSrvc, previewSrvc, orderproductPermissionsConst, orderProductEditModalSrvc,
        previewModalSrvc, datatableDefaultPageSizeValueConst, datatableDefaultEmptyValueConst,
        errorNotificationSrvc, orderDeliveryPackageDataSrvc, orderDeliveryPackageMessageConst, noteModalSrvc,
        notesDataSrvc, notesPageSizeConst, notesPermissionsConst, sourceFileModalSrvc, orderShelfPermissionsConst,
        orderShelfModalSrvc, orderShelfDataSrvc,
        montageDataSrvc, allegroThreadsDataSrvc)
    {
        var self = this;

        self.defaultEmpty = datatableDefaultEmptyValueConst;

        self.orderDuplicating = false;
        self.loadingProducts = true;
        self.loadingLogs = true;
        self.loadingNotes = true;
        self.externalOrderConfirmLoading = false;

        self.notes = [];

        self.logsPageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.openFileModal = openFileModal;
        self.previewOrderFile = previewOrderFile;
        self.getOrderProductProductionLogs = getOrderProductProductionLogs;
        self.getOrderAllegroMessagesByClient = getOrderAllegroMessagesByClient;
        self.editOrderProduct = editOrderProduct;
        self.hasOrderProductUpdatePermissions = hasOrderProductUpdatePermissions;

        self.order = {};
        self.orderShelf = {};
        self.clientData = {};
        self.orderAllegroMessages = [];

        self.serverErrors = {};
        self.orderProductCols = [{
            title: 'Podgląd',
            value: 'product_file.client_file_thumbnail',
            type: 'image',
            onClick: self.previewOrderFile,
            helpers: [{
                elementClass: 'preflight-status-icon ',
                tooltip: 'product_file.preflight_status.message',
                typeClass: 'product_file.preflight_status.class'
            }, {
                elementClass: 'preflight-accept-icon fa fa-check-circle text-navy',
                typeClass: 'fa fa-check-circle text-navy',
                directTooltip: true,
                tooltip: 'Podgląd zaakceptowany',
                conditionProp: '_preview_accepted'
            }]
        }, {
            title: 'ID zlecenia',
            value: 'pk',
            type: 'number',
        }, {
            title: 'Nr montażu',
            value: 'montage_pk',
            type: 'link',
            linkTo: 'layout.montage.update',
            linkParamProp: 'montage_pk',
            popover: {
                title: 'Logi produkcyjne',
                templateUrl: 'app/montage/views/montage-logs-popover/montage-logs-popover.html',
                openAction: 'mouseenter',
                onInit: getOrderProductProductionLogs
            }
        }, {
            title: 'ID produktu',
            value: 'product_pk',
            type: 'number',
        }, {
            title: 'Produkt',
            value: 'product_name',
            type: 'text'
        }, {
            title: 'Nakład',
            value: 'selected_quantity',
            type: 'text'
        }, {
            title: 'Format',
            value: 'format',
            type: 'text'
        }, {
            title: 'Netto',
            value: 'net_price',
            type: 'decimal'
        }, {
            title: 'Waluta',
            value: 'currency',
            type: 'text'
        }, {
            title: 'Waga',
            value: 'weight',
            type: 'decimal'
        }, {
            title: 'Opcje',
            value: 'chosen_options',
            type: 'list',
            fields: [{
                value: 'chosen_option.group_pk',
                class: 'label label-default'
            }, {
                value: 'chosen_option.group_name',
                class: null
            }, {
                value: 'chosen_option.pk',
                class: 'label label-default'
            }, {
                value: 'chosen_option.label',
                class: null
            }, {
                value: 'user_value',
                class: 'option-value'
            }]
        }];
        self.orderProductExtraActions = [{
            class: 'btn btn-xs',
            iconClass: 'fa fa-pencil',
            onClick: self.editOrderProduct,
            isDisabled: isOrderProductEditNotAllowed,
            displayCondition: isOrderProductEditNotAllowed,
            withLoading: true,
            title: 'Edytuj pozycję'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-upload',
            onClick: self.openFileModal,
            isDisabled: previewSrvc.isAdminCanNotUploadFile,
            displayCondition: previewSrvc.isAdminCanNotUploadFile,
            withLoading: true,
            title: 'Wyślij plik projektu'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientFile,
            isDisabled: previewSrvc.isClientFileNotAvailable,
            withLoading: true,
            title: 'Plik klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getResultFile,
            isDisabled: previewSrvc.isResultFileNotAvailable,
            withLoading: true,
            title: 'Plik wyjściowy'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientCoverFile,
            isDisabled: previewSrvc.isClientCoverFileNotAvailable,
            displayCondition: previewSrvc.isClientCoverFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getCoverResultFile,
            isDisabled: previewSrvc.isCoverResultFileNotAvailable,
            displayCondition: previewSrvc.isCoverResultFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki wyjściowy',
        }];

        self.orderLogs = [];
        self.orderLogCols = [{
            title: 'Autor',
            value: 'author_display',
            type: 'text'
        }, {
            title: 'Status',
            value: 'status_display',
            type: 'text'
        }, {
            title: 'Status płatności',
            value: 'payment_status_display',
            type: 'text'
        }, {
            title: 'Status dostawy',
            value: 'delivery_status_display',
            type: 'text'
        }, {
            title: 'Data',
            value: 'created',
            type: 'date'
        }];

        self.orderAddressProductCols = [{
            title: 'ID zlecenia',
            value: 'order_product_pk',
            type: 'number',
        }, {
            title: 'Nr montażu',
            value: 'montage_pk',
            type: 'number',
        }, {
            title: 'ID produktu',
            value: 'product_pk',
            type: 'number',
        }, {
            title: 'Produkt',
            value: 'product_name',
            type: 'text'
        }, {
            title: 'Nakład',
            value: 'amount',
            type: 'text'
        }, {
            title: 'Waga',
            value: 'weight',
            type: 'decimal'
        }, {
            title: 'Waga wysłana',
            value: 'real_weight',
            type: 'decimal'
        }];

        self.orderAddressTrackingCols = [{
            title: 'Miasto',
            value: 'city',
            type: 'text'
        }, {
            title: 'Data',
            value: 'date',
            type: 'date'
        }, {
            title: 'Status',
            value: 'description',
            type: 'text'
        }];

        self.hasOrderUpdatePermissions = hasOrderUpdatePermissions;
        self.hasOrderDuplicatePermissions = hasOrderDuplicatePermissions;

        self.isDisablePaid = orderSrvc.isDisablePaid;
        self.isDisableCompleted = orderSrvc.isDisableCompleted;
        self.isDisableCanceled = orderSrvc.isDisableCanceled;
        self.isDisableStopDelivery = orderSrvc.isDisableStopDelivery;
        self.isDisableUnstopDelivery = orderSrvc.isDisableUnstopDelivery;
        self.isDisableExternalOrderConfirm = orderSrvc.isDisableExternalOrderConfirm;

        self.duplicateOrder = duplicateOrder;
        self.payAnOrder = payAnOrder;
        self.completeAnOrder = completeAnOrder;
        self.cancelAnOrder = cancelAnOrder;
        self.stopDelivery = stopDelivery;
        self.unstopDelivery = unstopDelivery;

        self.getOrderCard = orderSrvc.getOrderCard;

        self.invoiceLoading = {
            proforma: false,
            advance: false,
            final: false,
            vat: false
        };
        self.getProformaInvoicePdf = getProformaInvoicePdf;
        self.getAdvanceInvoicePdf = getAdvanceInvoicePdf;
        self.getFinalInvoicePdf = getFinalInvoicePdf;
        self.getVATInvoicePdf = getVATInvoicePdf;

        self.hasInvoiceAddPermissions = hasInvoiceAddPermissions;
        self.isVisibleIssueVatInvoice = orderSrvc.isVisibleIssueVatInvoice;
        self.issueVatInvoiceLoading = false;
        self.issueVatInvoice = issueVatInvoice;

        self.hasOrderDeliveryAddressUpdatePermissions = hasOrderDeliveryAddressUpdatePermissions;
        self.updateTrackingNumber = updateTrackingNumber;
        self.updateDeliveryAddress = updateDeliveryAddress;

        self.logsPageChange = logsPageChange;

        self.isAnyInvoice = isAnyInvoice;

        self.updateDeliveryMethod = updateDeliveryMethod;
        self.externalOrderConfirm = externalOrderConfirm;

        self.negotiateOrderPrice = negotiateOrderPrice;
        self.updateSenderAddress = updateSenderAddress;
        self.setAsPickupedPackage = setAsPickupedPackage;
        self.openNoteModal = openNoteModal;
        self.openDeleteNoteModal = openDeleteNoteModal;
        self.openSourceFileModal = openSourceFileModal;
        self.canOrderShelfCreate = canOrderShelfCreate;
        self.openOrderShelfModal = openOrderShelfModal;

        activate();

        function activate() {
            self.isCanDisplayNotes = canDisplayNotes();
            self.isCanCreateNotes = canCreateNotes();
            self.isCanUpdateNotes = canUpdateNotes();
            self.isCanDeleteNotes = canDeleteNotes();
            getOrder();
            getOrderShelfByOrderId($state.params.pk);
            getOrderLogs();
        }

        function getOrder() {
            self.loadingProducts = true;

            return orderDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(
                function(response) {
                    self.order = response;
                    self.order.order_products.forEach(
                        function(op) {
                            op._preview_accepted = op.product_file && op.product_file.preview_accepted;
                        }
                    );

                    self.getOrderAllegroMessagesByClient(self.order.client)
                    getClientData();
                    getOrderNotes();
                    return response;
                }
            ).finally(
                function(response) {
                    self.loadingProducts = false;
                }
            );
        }

        function getOrderLogs() {
            self.loadingLogs = true;

            return orderLogDataSrvc.list({
                order_pk: $state.params.pk,
                page: self.logsPageOpts.page,
                page_size: self.logsPageOpts.pageSize,
            }).$promise.then(
                function(response) {
                    self.orderLogs = response.results;
                    self.logsPageOpts.count = response.count;
                    return response;
                }
            ).finally(
                function(response) {
                    self.loadingLogs = false;
                }
            );
        }

        function getOrderShelfByOrderId(orderId) {
            return orderShelfDataSrvc.list({order_pk: orderId})
                .$promise.then(
                    function (response) {
                        if (response.results.length > 0) {
                            self.orderShelf = response.results[0];
                        }
                        return response;
                    }
                ).finally(function (response) {
                    return response;
                });
        }

        self.hasOrderShelf = function() {
            return Object.keys(self.orderShelf).length > 0;
        };

        function getClientData() {
            return clientDataSrvc.getFlattened({
                pk: self.order.client.pk
            }).$promise.then(function(response) {
                self.clientData = response;
                return response;
            });
        }

        function hasOrderDuplicatePermissions() {
            return !checkModelPermissionsSrvc.isDenied(orderPermissionsConst.duplicate);
        }

        function hasOrderProductUpdatePermissions() {
            return !checkModelPermissionsSrvc.isDenied(orderproductPermissionsConst.update);
        }

        function isOrderProductEditNotAllowed() {
            return !self.hasOrderProductUpdatePermissions() || !self.order.can_edit_order_products;
        }

        function editOrderProduct(orderProduct) {
            return orderProductEditModalSrvc.editOrderProduct(orderProduct, getOrder, angular.noop);
        }

        function hasOrderUpdatePermissions() {
            return !checkModelPermissionsSrvc.isDenied(
                orderPermissionsConst.update);
        }

        function hasInvoiceAddPermissions() {
            return !checkModelPermissionsSrvc.isDenied(
                invoicePermissionsConst.add);
        }

        function hasOrderDeliveryAddressUpdatePermissions() {
            return !checkModelPermissionsSrvc.isDenied(
                orderDeliveryAddressPermissionsConst.update);
        }

        function updateTrackingNumber(address) {
            if (!self.hasOrderDeliveryAddressUpdatePermissions()) {
                notificationSrvc.notification("error", orderDeliveryAddressPermissionsConst.errorMsg);
                return null;
            }

            modalSrvc.confirmAction(
                orderUpdateMessagesConst.updateTrackingNumber,
                function() {
                    orderDeliveriesDataSrvc.update({
                        pk: address.pk
                    }, {
                        ups_tracking_number: address.ups_tracking_number
                    }).$promise.then(
                        function(response) {
                            notificationSrvc.notification("success", orderUpdateMessagesConst.add_tracking);
                            return response;
                        },
                        function(response) {
                            errorNotificationSrvc.displayErrors(response.data);
                            self.serverErrors = response.data;
                        }
                    );
                }
            );
        }

        function updateDeliveryAddress(address) {
            if (!hasOrderDeliveryAddressUpdatePermissions()) {
                notificationSrvc.notification("error", orderDeliveryAddressPermissionsConst.view.errorMsg);
                return;
            }

            $uibModal.open({
                templateUrl: 'app/order/views/delivery-address-update/delivery-address-update.html',
                controller: 'DeliveryAddressUpdateController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    address: function() {
                        return address;
                    }
                }
            });
        }

        function isAnyInvoice() {
            return self.order.proforma_invoice ||
                self.order.advance_invoice ||
                self.order.final_invoice ||
                self.order.vat_invoice;
        }

        function logsPageChange() {
            return getOrderLogs();
        }

        function duplicateOrder(order) {
            orderSrvc.duplicateOrder(
                order,
                function() {
                    self.orderDuplicating = true;
                },
                function(newOrder) {
                    self.orderDuplicating = false;
                    $state.go('layout.order.details', { pk: newOrder.pk });
                },
                function() {
                    self.orderDuplicating = false;
                }
            );
        }

        function payAnOrder(order) {
            return orderSrvc.payAnOrder(order, getOrderLogs);
        }

        function completeAnOrder(order) {
            return orderSrvc.completeAnOrder(order, getOrderLogs);
        }

        function cancelAnOrder(order) {
            return orderSrvc.cancelAnOrder(order, getOrderLogs);
        }

        function stopDelivery(order) {
            return orderSrvc.stopDelivery(order, getOrderLogs);
        }

        function unstopDelivery(order) {
            return orderSrvc.unstopDelivery(order, getOrderLogs);
        }

        function getProformaInvoicePdf(orderPk) {
            if (!self.invoiceLoading.proforma) {
                self.invoiceLoading.proforma = true;
                orderSrvc.getProformaInvoicePdf(orderPk).then(
                    function () {
                        self.invoiceLoading.proforma = false;
                    },
                    function () {
                        self.invoiceLoading.proforma = false;
                    }
                )
            }
        }

        function getAdvanceInvoicePdf(orderPk) {
            if (!self.invoiceLoading.advance) {
                self.invoiceLoading.advance = true;
                orderSrvc.getAdvanceInvoicePdf(orderPk).then(
                    function () {
                        self.invoiceLoading.advance = false;
                    },
                    function () {
                        self.invoiceLoading.advance = false;
                    }
                )
            }
        }

        function getFinalInvoicePdf(orderPk) {
            if (!self.invoiceLoading.final) {
                self.invoiceLoading.final = true;
                orderSrvc.getFinalInvoicePdf(orderPk).then(
                    function () {
                        self.invoiceLoading.final = false;
                    },
                    function () {
                        self.invoiceLoading.final = false;
                    }
                )
            }
        }

        function getVATInvoicePdf(orderPk) {
            if (!self.invoiceLoading.vat) {
                self.invoiceLoading.vat = true;
                orderSrvc.getVATInvoicePdf(orderPk).then(
                    function () {
                        self.invoiceLoading.vat = false;
                    },
                    function () {
                        self.invoiceLoading.vat = false;
                    }
                )
            }
        }

        function updateDeliveryMethod() {
            $uibModal.open({
                templateUrl: 'app/order/views/order-delivery-update-modal/order-delivery-update-modal.html',
                controller: 'OrderDeliveryUpdateModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    order: function() {
                        return self.order;
                    }
                }
            }).result.then(
                function(result) {
                    activate();
                }
            );
        }

        function externalOrderConfirm() {
            self.externalOrderConfirmLoading = true;
            orderDataSrvc.externalOrderConfirm({
                pk: self.order.pk
            }).$promise.then(
                function (response) {
                    activate();
                    self.externalOrderConfirmLoading = false;
                    notificationSrvc.notification("success", orderUpdateMessagesConst.externalOrderConfirmSuccess);
                },
                function (response) {
                    self.externalOrderConfirmLoading = false;
                    notificationSrvc.notification("error", orderUpdateMessagesConst.externalOrderConfirmError);
                }
            )
        }

        function issueVatInvoice(order) {
            modalSrvc.confirmAction(
                orderUpdateMessagesConst.confirmIssueVatInvoiceTitle,
                function() {
                    self.issueVatInvoiceLoading = true;
                    orderDataSrvc.issueVatInvoice({
                        pk: order.pk
                    }).$promise.then(
                        function(response) {
                            notificationSrvc.notification("success", orderUpdateMessagesConst.issueVatInvoiceSuccess);
                            return getOrder();
                        },
                        function(response) {
                            notificationSrvc.notification("error", response.data.nonFieldErrors.join('; '));
                        }
                    ).finally(
                        function() {
                            self.issueVatInvoiceLoading = false;
                        }
                    );
                }
            );
        }

        function negotiateOrderPrice(order) {
            $uibModal.open({
                templateUrl: 'app/order/views/order-negotiate-modal/order-negotiate-modal.html',
                controller: 'OrderNegotiateModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    order: function() {
                        return order;
                    }
                }
            }).result.then(
                function(result) {
                    activate();
                }
            );
        }

        function updateSenderAddress(order) {
            $uibModal.open({
                templateUrl: 'app/order/views/order-sender-address-modal/order-sender-address-modal.html',
                controller: 'OrderSenderAddressModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    order: function() {
                        return order;
                    }
                }
            }).result.then(
                function(result) {
                    activate();
                }
            );
        }

        function setAsPickupedPackage(deliveryPackage) {
            return orderDeliveryPackageDataSrvc.statusUpdate(
                {pk: deliveryPackage.pk},
                {status: "pickuped"}
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", orderDeliveryPackageMessageConst.setAsPickupedSuccess);
                    deliveryPackage.status = response.status;
                    activate();
                    return response;
                },
                function(reason) {
                    if (reason.data.status){
                        notificationSrvc.notification("error", reason.data.status[0]);
                    } else {
                        notificationSrvc.notification("error", orderDeliveryPackageMessageConst.setAsPickupedError);
                    }
                }
            );
        }

        function openNoteModal(order, note) {
            noteModalSrvc.modal(order, note, getOrderNotes, angular.noop)
        }

        function openDeleteNoteModal(note) {
            noteModalSrvc.remove(note, getOrderNotes, angular.noop)
        }

        function getOrderNotes() {
            if (!self.isCanDisplayNotes || !self.order) {
                self.loadingNotes = false;
                return;
            }

            self.loadingNotes = true;

            return notesDataSrvc.list({
                content_type: self.order.content_type_pk,
                object_id: self.order.pk,
                page_size: notesPageSizeConst
            }).$promise.then(
                function(response) {
                    self.notes = response.results;
                    return response;
                }
            ).finally(
                function(response) {
                    self.loadingNotes = false;
                }
            );
        }

        function canDisplayNotes() {
            return !checkModelPermissionsSrvc.isDenied(notesPermissionsConst.view);
        }

        function canCreateNotes() {
            return !checkModelPermissionsSrvc.isDenied(notesPermissionsConst.add);
        }

        function canUpdateNotes() {
            return !checkModelPermissionsSrvc.isDenied(notesPermissionsConst.update);
        }

        function canDeleteNotes() {
            return !checkModelPermissionsSrvc.isDenied(notesPermissionsConst.delete);
        }

        function openFileModal(orderProduct) {
            previewModalSrvc.openFileModal(orderProduct, activate, angular.noop)
        }

        function previewOrderFile(orderProduct){
            previewSrvc.previewOrderFile(orderProduct, activate, angular.noop)
        }

        function openSourceFileModal(orderProduct){
            sourceFileModalSrvc.openSourceFileModal(orderProduct, activate, angular.noop)
        }

        function canOrderShelfCreate() {
            return !checkModelPermissionsSrvc.isDenied(orderShelfPermissionsConst.add);
        }

        function onSaveOrderShelf(data) {
            activate();
        }

        function openOrderShelfModal(order) {
            orderShelfModalSrvc.modal(order, onSaveOrderShelf, angular.noop)
        }

        function getOrderProductProductionLogs($event, orderProduct) {
            $event.stopPropagation();

            if (orderProduct.production_logs) {
                return $q.when(orderProduct.production_logs);
            }

            return montageDataSrvc.getMontageProductionLogs({pk: orderProduct.montage_pk}).$promise.then(
                function (response) {
                    orderProduct['production_logs'] = response.toJSON().results;
                    return response;
                }
            );
        }

        function getOrderAllegroMessagesByClient(client) {
            return allegroThreadsDataSrvc.list({client_pk: client.pk}).$promise.then(
                function (response) {
                    self.orderAllegroMessages = response.results
                    return response;
                }
            );
        }
    }
})();
